import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import { Grid, FormControl, InputLabel } from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker";
import { appConstants } from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";
import { connect } from "react-redux";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  root: {
    flexGrow: 1,
    paddingLeft: "15px",
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 100,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 1,
  },
  searchButton: {
    backgroundColor: " #66bb6a",
  },
  airlineSelect: { marginTop: "0px", width: "100%" },
  Grid: {
    flexBasis: "14px",
  },
});

function SearchComponent(props) {
  // let { classes, airlines, selectChange, AirlineId, FlightNumber, StartDate, EndDate, flightNumbers } = props;
  let {
    classes,
    StartDate,
    EndDate,
    airlines,
    selectChange,
    flightNumbers,
    onSearch,
    handleDateChange,
    user,
    allLocations,
    AirportCode,
    AirlineId,
    serviceType,
    serviceTypes,
  } = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item md={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airlines
            </InputLabel>
            <AutocompleteSelect
              options={airlines.map((option) => ({
                value: option.AirlineId,
                label: option.Airline,
              }))}
              selectedOption={AirlineId}
              handleSelectChange={(e, name) => selectChange(e, name)}
              selectLabel={"Airlines"}
              disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              name={"AirlineId"}
            />
          </FormControl>
        </Grid>
        <Grid item md={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              All Flights
            </InputLabel>
            <AutocompleteSelect
              options={flightNumbers.map((option) => ({
                value: option.FlightNumber,
                label: option.FlightNumber,
              }))}
              name={"FlightNumber"}
              handleSelectChange={(e, name) => selectChange(e, name)}
            />
          </FormControl>
        </Grid>
        <Grid item md={3}>
          <div>
            <InlineDatePicker
              label={"Start Date"}
              Date={StartDate}
              handleDateChange={(date) => handleDateChange(date, "StartDate")}
            />
          </div>
        </Grid>
        <Grid item md={3}>
          <div>
            <InlineDatePicker
              label={"End Date"}
              Date={EndDate}
              handleDateChange={(date) => handleDateChange(date, "EndDate")}
            />
          </div>
        </Grid>
        <Grid item md={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airports
            </InputLabel>
            <AutocompleteSelect
              options={allLocations.map((option) => ({
                value: option.Code,
                label: option.Name,
              }))}
              name={"AirportCode"}
              handleSelectChange={(e, name) => selectChange(e, name)}
              disabled={
                user.AppRole === appConstants.ROLES.AIRPORT_MANAGER ||
                user.Location
              }
              selectedOption={AirportCode}
            />
          </FormControl>
        </Grid>
        <Grid item md={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Service Type
            </InputLabel>
            <AutocompleteSelect
              options={serviceTypes.map((option) => ({
                value: option.Id,
                label: option.Name,
              }))}
              name={"serviceType"}
              handleSelectChange={(e, name) => selectChange(e, name)}
              selectedOption={serviceType}
            />
          </FormControl>
        </Grid>
        <Grid item>
          <Button
            color={props.setView === "regional" ? "regional" : "success"}
            onClick={() => onSearch()}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

SearchComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  selectChange: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  const { setView } = state;
  return {
    setView,
  };
}
export default connect(mapStateToProps)(withStyles(styles)(SearchComponent));



// WEBPACK FOOTER //
// ./src/Regional-Views/AirlinesPassenger/SearchPanel.jsx